export default __webpack_public_path__ + "static/media/easyNpsLogo.7c7e088e.png";